global.Promise = global.Promise || require('es6-promise').Promise;

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter as Router } from 'react-router-dom';
import { syncHistoryWithStore } from 'react-router-redux';
import { createBrowserHistory } from 'history';

import routes from './routes.js';
import configureStore from './redux/configure-store.js';

const history = createBrowserHistory();
const initialState = {};

const store = configureStore(initialState);

const syncedHistory = syncHistoryWithStore(history, store);

let rootElement = null;

if (process.env.DEVTOOLS) {
  const DevTools = require('./redux/DevTools');
  rootElement = (
    <Provider store={store}>
      <div>
        <Router history={syncedHistory}>
          {routes}
        </Router>
        <DevTools/>
      </div>
    </Provider>
  );
}
else {
  rootElement = (
    <Provider store={store}>
      <Router history={syncedHistory}>
        {routes}
      </Router>
    </Provider>
  );
}

ReactDOM.render(rootElement, document.getElementById('app-container'));



// WEBPACK FOOTER //
// ./src/bootstrap.js